export interface DossierAbandonSuccess {
  type: 'success';
  comment: string;
}

export interface DossierAbandonCancel {
  type: 'cancel';
}

export interface DossierAbandonLater {
  type: 'later';
  comment: string;
}

export type DossierAbandonOutputData =
  | DossierAbandonSuccess
  | DossierAbandonLater
  | DossierAbandonCancel;
